"use client";

import { createContext, useContext } from "react";
import { KeywordsPageResponse } from "./entitites/KeywordsResponse";

export interface CasinoPageContextValue {
  domain?: string;
  website?: KeywordsPageResponse;
}

export const CasinoPageContext = createContext<CasinoPageContextValue>({} as CasinoPageContextValue);

export function useCasinoPage() {
  return useContext(CasinoPageContext);
}
